import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Trash2, PlusCircle, ChevronRight } from 'lucide-react'; // Icônes pour le design
import './MemoiresMentionnes.css'; 

function MemoiresMentionnes({ onThesisClick }) {
  const navigate = useNavigate();
  
  // Vérification du rôle admin
  const isAdmin = localStorage.getItem("role") === "admin";

  // Génération des années
  const years = Array.from({ length: 2024 - 2016 + 1 }, (_, i) => 2024 - i);

  const [selectedYear, setSelectedYear] = useState(years[0]);
  const [allMemoires, setAllMemoires] = useState([]);
  const [loading, setLoading] = useState(true);

  // 1. Récupérer les données réelles
  useEffect(() => {
    const fetchMemoires = async () => {
      try {
        setLoading(true);
        const res = await axios.get("https://api.memofacdz.com/api/memoires");
        setAllMemoires(res.data);
      } catch (err) {
        console.error("Erreur de récupération:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchMemoires();
  }, []);

  // 2. Fonction de suppression (Admin uniquement)
  const handleDelete = async (id, e) => {
    e.stopPropagation(); // Empêche d'ouvrir les détails
    if (window.confirm("Voulez-vous vraiment supprimer ce mémoire ?")) {
      try {
        const token = localStorage.getItem("token");
        await axios.delete(`https://api.memofacdz.com/api/memoires/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        // Mise à jour de l'affichage local
        setAllMemoires(allMemoires.filter(m => m._id !== id));
      } catch (err) {
        alert("Erreur lors de la suppression.");
      }
    }
  };

  // 3. Filtrage par année
  const filteredTheses = allMemoires.filter(
    (thesis) => Number(thesis.annee) === selectedYear
  );

  return (
    <div className="memoires-page">
      <section className="memoires-content-wrapper">
        
        {/* Sidebar */}
        <aside className="year-sidebar glass-card-sidebar">
          <h2>Années</h2>
          <ul>
            {years.map((year) => (
              <li 
                key={year}
                className={selectedYear === year ? 'active' : ''}
                onClick={() => setSelectedYear(year)}
              >
                {year}
              </li>
            ))}
          </ul>
        </aside>

        {/* Main Content */}
        <main className="theses-main-content">
          <div className="theses-header">
            <h1>Mémoires mentionnées de l'année {selectedYear}</h1>
            
            {/* Bouton Ajouter en haut pour l'Admin */}
            {isAdmin && (
              <button 
                className="add-memoire-page-btn"
                onClick={() => navigate("/add-memoire")}
              >
                <PlusCircle size={18} /> Ajouter un Mémoire
              </button>
            )}
          </div>
          
          <div className="theses-list">
            {loading ? (
              <div className="glass-card"><p>Chargement des données...</p></div>
            ) : filteredTheses.length > 0 ? (
              filteredTheses.map((thesis) => (
                <div 
                  key={thesis._id} 
                  className="thesis-card clickable-card"
                  onClick={() => onThesisClick(thesis)}
                >
                  <div className="thesis-card-content">
                    {thesis.Couverture_R && (
                      <img 
                        src={thesis.Couverture_R ?`https://api.memofacdz.com${thesis.Couverture_R}`  : "/placeholder-cover.jpg"} 
                        alt="Couverture" 
                        className="thesis-mini-cover" 
                      />
                    )}
                    <div className="thesis-card-info">
                      <h3>{thesis.intitule_M}</h3>
                      <p>Auteur: <strong>{thesis.Ecrivain}</strong></p>
                      <div className="thesis-tags">
                        {thesis.mots_cles?.slice(0, 3).map((tag, i) => (
                          <span key={i} className="mini-tag">#{tag}</span>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="card-actions">
                    <span className="click-instruction">Détails <ChevronRight size={14}/></span>
                    
                    {/* Bouton Supprimer (Admin) */}
                    {isAdmin && (
                      <button 
                        className="delete-memoire-btn"
                        onClick={(e) => handleDelete(thesis._id, e)}
                      >
                        <Trash2 size={16} />
                      </button>
                    )}
                  </div>
                </div>
              ))
            ) : (
               <div className="glass-card">
                 <p>Aucune memoire enregistrée pour l'année {selectedYear}.</p>
               </div>
            )}
          </div>
        </main>

      </section>
    </div>
  );
}

export default MemoiresMentionnes;